import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionDesignTokens = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"type": "page",
			"properties": {
				"title": [
					[
						"Дизайн-токены"
					]
				]
			},
			"content": [
				"70713030-679e-44d3-9da2-e54ddcff45fc",
				"7c965406-05cf-4e7e-bffe-cffbaa461d66",
				"e813e73f-1dac-440e-af32-969b97d4e9e9",
				"bdee2906-d89c-4e81-b380-80a83ee3498f",
				"4882aa3a-a3ac-4429-a384-f4f1762f1bc9",
				"7b9e0230-c542-429b-b1f8-32bd166139c3",
				"1a067179-5cae-4962-a7d3-fa5b47440b48",
				"7920d34f-2c6b-4a47-9ed5-86ef67023ec2",
				"39ac242f-4ab2-4bae-9d76-5a9196016b51",
				"215f1d38-f797-4b46-a07a-bba632b93716",
				"592fa0c6-ec44-4627-8c94-ee2f2b9228e5",
				"280c6aa1-ef67-42c4-8f59-b845e0f53daa",
				"4bc7f532-e55c-47c2-92f9-f58e8bbff545",
				"a254a4a3-91f9-4a2a-8dcf-289c340a9cc6",
				"a87df927-2b77-4c55-b2f6-44348dee5277",
				"d7aa8a18-147f-4d1e-87f1-382136b4222a",
				"fde2e2c2-d7bf-43d8-868b-af53c845d6c2",
				"73dca857-b414-434e-bb1a-258e115a3720",
				"42013cf8-9190-4a80-8353-eb16738c2445"
			],
			"format": {
				"copied_from_pointer": {
					"id": "4f36900c-bdf9-4b9c-bdd5-f6ab52b25931",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"ef92698d-7beb-4775-90d8-5ca24ab5ddda"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "70713030-679e-44d3-9da2-e54ddcff45fc",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/design_tokens\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d2d1897d-18e4-4018-8dcb-112e2ad5c238",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7c965406-05cf-4e7e-bffe-cffbaa461d66",
			"type": "header",
			"properties": {
				"title": [
					[
						"Что это такое"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "be10fe04-5393-47b3-910d-8100999f95a7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e813e73f-1dac-440e-af32-969b97d4e9e9",
			"type": "text",
			"properties": {
				"title": [
					[
						"Дизайн-токены — это набор базовых переменных визуального языка — отступы, цвета, типографика, стили объектов, анимация — представленный в виде данных. В них цвет представляется как значение RGB, прозрачность как число, анимация как координаты Безье. Токены используют вместо жестко запрограммированных значений, чтобы было легко управлять визуальным стилем  и обеспечивать единство во всех продуктах."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f327a5b7-eda0-477c-aae2-287378c28f5b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bdee2906-d89c-4e81-b380-80a83ee3498f",
			"type": "header",
			"properties": {
				"title": [
					[
						"Использование в дизайне"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "84dd7ee8-8e25-478f-85da-d409c11a6ab2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4882aa3a-a3ac-4429-a384-f4f1762f1bc9",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы используем общий открытый репозиторий с токенами VKUI. Дизайн-токены интегрированы в наши библиотеки компонентов и UI-киты. Они охватывают разные платформы, цветовые темы, состояния компонентов и многое другое. Название цветов и типографики в наших библиотеках в Figma соответствуют названию токена в репозитории. Это упрощает разработку: например, если изменить цвет в репозитории, он изменится одновременно в разных продуктах. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "98b59c52-7205-4e9a-bdd4-9b9c342da4ca",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7b9e0230-c542-429b-b1f8-32bd166139c3",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://vkcom.github.io/vkui-tokens/"
					]
				],
				"title": [
					[
						"VKUI Tokens documentation"
					]
				],
				"caption": [
					[
						"Токены для продуктов VK"
					]
				],
				"description": [
					[
						"Webpack React description"
					]
				]
			},
			"format": {
				"bookmark_icon": "https://vkcom.github.io/static/meta/favicon.ico"
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1a067179-5cae-4962-a7d3-fa5b47440b48",
			"type": "text",
			"properties": {
				"title": [
					[
						"Благодаря токенам мы поддерживаем и развиваем сразу темную и светлую темы интерфейса. Используя Variables в Figma переключать темы очень просто."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "466ff8c9-a6a8-4c7c-89e0-3c0ee8557157",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7920d34f-2c6b-4a47-9ed5-86ef67023ec2",
			"type": "image",
			"properties": {
				"size": [
					[
						"154.5KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/838e8a42-988c-4266-becb-cb4dc7fbdaa2/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/838e8a42-988c-4266-becb-cb4dc7fbdaa2/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.3873626373626374,
				"copied_from_pointer": {
					"id": "ce097a2f-5f7e-4464-8ebb-bb576d21a769",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"file_ids": [
				"838e8a42-988c-4266-becb-cb4dc7fbdaa2"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/7920d34f-2c6b-4a47-9ed5-86ef67023ec2.png"
		},
		{
			"id": "39ac242f-4ab2-4bae-9d76-5a9196016b51",
			"type": "header",
			"properties": {
				"title": [
					[
						"Токены для разработки"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c21abd5c-eb57-41fe-b9ce-c27423c119b5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "215f1d38-f797-4b46-a07a-bba632b93716",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для описания токенов используется "
					],
					[
						"TypeScript",
						[
							[
								"b"
							]
						]
					],
					[
						". Дизайн-токены собраны в один npm-пакет для быстрой установки и подключения к проекту. Генератор позволяет экспортировать токены в разных форматах: scss, less, css in JS и т.п."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "bf7c4dc3-e3f7-40cd-a128-82b361928a4a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "592fa0c6-ec44-4627-8c94-ee2f2b9228e5",
			"type": "image",
			"properties": {
				"size": [
					[
						"132.2KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c55c76ee-bd6b-4d8d-a5f3-f5d311a3c14f/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c55c76ee-bd6b-4d8d-a5f3-f5d311a3c14f/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.3873626373626374,
				"copied_from_pointer": {
					"id": "fd663838-c7c7-4d50-9d55-b78fc59dee04",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"file_ids": [
				"c55c76ee-bd6b-4d8d-a5f3-f5d311a3c14f"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/592fa0c6-ec44-4627-8c94-ee2f2b9228e5.png"
		},
		{
			"id": "280c6aa1-ef67-42c4-8f59-b845e0f53daa",
			"type": "header",
			"properties": {
				"title": [
					[
						"Тематизация"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ce335b4a-4f99-45ec-8003-dce5d6bf266d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4bc7f532-e55c-47c2-92f9-f58e8bbff545",
			"type": "text",
			"properties": {
				"title": [
					[
						"Разные продукты используют свои темы оформления. Любая тема наследуется от базовой, но меняет значения некоторых переменных. Например, есть отдельные темы для продуктов productivity и media, но все они основаны на базовой теме. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2b05a9c2-601a-4912-927b-dd0e490037b8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a254a4a3-91f9-4a2a-8dcf-289c340a9cc6",
			"type": "text",
			"properties": {
				"title": [
					[
						"Такой подход помог в разработке темной темы интерфейса. Токены темной темы тонируют цветовые токены базовой темы.    "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b4b0812a-1fbd-4ff6-b172-fbdb797ba7c9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a87df927-2b77-4c55-b2f6-44348dee5277",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b78343d0-712d-463c-839d-7d9e95f5318a/themes.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b78343d0-712d-463c-839d-7d9e95f5318a/themes.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.49725274725274726,
				"copied_from_pointer": {
					"id": "58cf424e-215f-4f81-82d9-fd519d13db08",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"file_ids": [
				"b78343d0-712d-463c-839d-7d9e95f5318a"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/a87df927-2b77-4c55-b2f6-44348dee5277.png"
		},
		{
			"id": "d7aa8a18-147f-4d1e-87f1-382136b4222a",
			"type": "header",
			"properties": {
				"title": [
					[
						"Адаптивность"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a2d51385-9bd4-4aa8-bade-28738f475a45",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fde2e2c2-d7bf-43d8-868b-af53c845d6c2",
			"type": "text",
			"properties": {
				"title": [
					[
						"Наши токены реализованы с учётом адаптивности: отдельные переменные и классы имеют разные значения на разных вьюпортах. Такой подход облегчает работу, потому что переносит часть адаптивности на уровень переменных."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "818c30a4-db2e-46b0-bfd6-2712d45d7182",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "73dca857-b414-434e-bb1a-258e115a3720",
			"type": "image",
			"properties": {
				"size": [
					[
						"132.2KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a87547f4-74f1-4f5a-83bd-9a380f806069/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a87547f4-74f1-4f5a-83bd-9a380f806069/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.49725274725274726,
				"copied_from_pointer": {
					"id": "da9dee4f-3a58-43a1-a48f-0fa7f52a0fca",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"file_ids": [
				"a87547f4-74f1-4f5a-83bd-9a380f806069"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/73dca857-b414-434e-bb1a-258e115a3720.png"
		},
		{
			"id": "42013cf8-9190-4a80-8353-eb16738c2445",
			"type": "text",
			"parent_id": "7472c506-f9da-4f2e-85ba-59623551e747",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Что это такое",
			"id": "7c965406-05cf-4e7e-bffe-cffbaa461d66"
		},
		{
			"title": "Использование в дизайне",
			"id": "bdee2906-d89c-4e81-b380-80a83ee3498f"
		},
		{
			"title": "Токены для разработки",
			"id": "39ac242f-4ab2-4bae-9d76-5a9196016b51"
		},
		{
			"title": "Тематизация",
			"id": "280c6aa1-ef67-42c4-8f59-b845e0f53daa"
		},
		{
			"title": "Адаптивность",
			"id": "d7aa8a18-147f-4d1e-87f1-382136b4222a"
		}
	]
}} />
);

export default NotionDesignTokens;
